import {Modal} from "bootstrap";
const newsletter_modal = document.getElementById("newsletter-modal");
if (newsletter_modal) {
	const myNewsletterModal = new Modal(newsletter_modal, {
		keyboard: false,
	});
	newsletter_modal.addEventListener("hide.bs.modal", function () {
		Cookies.set("popup", "1", {expires: 365, path: "/"});
	});
	setTimeout(() => {
		myNewsletterModal.show();
	}, 1000);
}

Fancybox.bind(
	'a[href*="jpg"], a[href*="jpeg"], a[href*="png"], a[href*="gif"], a[href*="JPEG"], a[href*="JPG"], a[href*="PNG"], a[href*="GIF"], a[href*="MP4"], a[href*="mp4"]',
	{
		groupAll: true,
		on: {
			done: (fancybox, slide) => {
				// console.log("done", fancybox, slide);
			},
		},
	}
);

/* const image_modal = document.getElementById("image-modal");
if (image_modal) {
	const modal_body = document.querySelector("#image-modal .modal-body");
	const modal_container = document.querySelector("#image-modal .modal-dialog");

	const myImageModal = new Modal(image_modal, {
		keyboard: false,
	});

	const image_links = document.querySelectorAll(
		'a[href*="jpg"], a[href*="jpeg"], a[href*="png"], a[href*="gif"], a[href*="JPEG"], a[href*="JPG"], a[href*="PNG"], a[href*="GIF"]'
	);
	image_modal.addEventListener("mousedown", function (evt) {
		evt.preventDefault();
	});
	image_modal.addEventListener("shown.bs.modal", function () {
		setTimeout(() => {
			image_modal.scrollIntoView({block: "end"});
		}, 1000);
	});
	image_modal.addEventListener("hidden.bs.modal", function () {
		jQuery("body").removeClass("loading");
	});
	Array.prototype.forEach.call(image_links, function (el, i) {
		const full_image_url = el.getAttribute("href");
		el.addEventListener("click", function (evt) {
			evt.preventDefault();
			const temp = new Image();
			modal_body.innerHTML = "";
			myImageModal.show();
			jQuery("body").addClass("loading");
			temp.addEventListener(
				"load",
				function () {
					modal_body.appendChild(temp);
					modal_container.style.width = `${Math.round(
						temp.width * 0.75
					)}px`;
					modal_container.style.height = `${Math.round(
						temp.height * 0.75
					)}px`;
					temp.addEventListener("click", function () {
						myImageModal.hide();
					});
					jQuery("body").removeClass("loading");
				},
				true
			);
			temp.src = full_image_url;
		});
	});
}
 */
